import { createFileRoute, redirect } from "@tanstack/react-router";

/** Page pleine remplacée par le volet dossier — cf. `overview.tsx`. */
export const Route = createFileRoute("/_authed/_dashboard/claims/$claimId/acquisition-history")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/claims",
      search: { claimId: params.claimId, claimTab: "acquisition-history" },
    });
  },
});
